(function () {
  var MIN_PRODUCTS_PER_PROMO = 4;

  function getProductItems(list) {
    return Array.prototype.filter.call(list.children, function (el) {
      return el.nodeType === 1 && el.matches('li[data-effilo-grid-product]');
    });
  }

  function isPromoPlaced(list, id) {
    return !!list.querySelector('[data-effilo-grid-promo-item][data-promo-id="' + id + '"]');
  }

  /**
   * Clones a promo <template> node for insertion into the grid.
   * @param {HTMLTemplateElement} template
   * @returns {Element|null}
   */
  function clonePromo(template) {
    var node = template.content.firstElementChild;
    if (!node) return null;
    return node.cloneNode(true);
  }

  function shuffle(array) {
    var i = array.length;
    while (i > 1) {
      var j = Math.floor(Math.random() * i);
      i -= 1;
      var tmp = array[i];
      array[i] = array[j];
      array[j] = tmp;
    }
    return array;
  }

  function placeGridImages(root) {
    var list = root.querySelector('[data-effilo-infinite-list]');
    if (!list) return;

    var templates = Array.prototype.slice.call(
      root.querySelectorAll('template[data-effilo-grid-promo]')
    );
    if (!templates.length) return;

    var randomize = root.dataset.effiloGridImagesRandomize === 'true';
    var products = getProductItems(list);
    if (!products.length) return;

    var pending = templates.filter(function (template) {
      return template.dataset.id && !isPromoPlaced(list, template.dataset.id);
    });
    if (!pending.length) return;

    if (randomize) {
      var placedCount = list.querySelectorAll('[data-effilo-grid-promo-item]').length;
      var maxPromosNow = Math.max(1, Math.floor(products.length / MIN_PRODUCTS_PER_PROMO));
      var room = Math.max(0, maxPromosNow - placedCount);
      if (!room) return;

      var batch = pending.slice(0, room);
      var occupied = {};
      Array.prototype.forEach.call(
        list.querySelectorAll('[data-effilo-grid-promo-item]'),
        function (promo) {
          var prev = promo.previousElementSibling;
          if (prev && prev.matches('li[data-effilo-grid-product]')) {
            var idx = products.indexOf(prev);
            if (idx >= 0) occupied[idx] = true;
          }
        }
      );

      var slots = products
        .map(function (_item, index) {
          return index;
        })
        .filter(function (index) {
          return !occupied[index];
        });

      shuffle(slots);

      var count = Math.min(batch.length, slots.length);
      var chosen = slots.slice(0, count).sort(function (a, b) {
        return b - a;
      });

      chosen.forEach(function (slotIndex, index) {
        var node = clonePromo(batch[index]);
        if (!node) return;
        products[slotIndex].after(node);
      });
      return;
    }

    pending.forEach(function (template) {
      var after = parseInt(template.dataset.insertAfter || '0', 10);
      if (!after || after < 1 || products.length < after) return;
      var node = clonePromo(template);
      if (!node) return;
      products[after - 1].after(node);
    });
  }

  /**
   * Boots infinite scroll on every uninitialized Effilo grid on the page.
   * When popular filters are active, pages are loaded from the filtered
   * collection alternate template instead of the list-collections section.
   * @returns {void}
   */
  function initInfiniteGrids() {
    document.querySelectorAll('[data-effilo-infinite-grid]').forEach(function (root) {
      if (root.dataset.effiloInfiniteInit === 'true') return;
      root.dataset.effiloInfiniteInit = 'true';

      if (root._effiloObserver) {
        root._effiloObserver.disconnect();
        root._effiloObserver = null;
      }

      var list = root.querySelector('[data-effilo-infinite-list]');
      var sentinel = root.querySelector('[data-effilo-infinite-sentinel]');
      if (!list) return;

      placeGridImages(root);

      if (!sentinel) return;

      var sectionEl = root.closest('.shopify-section');
      if (!sectionEl || !sectionEl.id) return;
      var sectionId = sectionEl.id.replace('shopify-section-', '');

      var page = parseInt(root.dataset.page || '1', 10);
      var pages = parseInt(root.dataset.pages || '1', 10);
      var loading = false;

      function setDone() {
        observer.disconnect();
        sentinel.hidden = true;
      }

      /**
       * Loads the next product page for either filtered or default catalog mode.
       * @returns {void}
       */
      function loadMore() {
        if (loading || page >= pages) return;
        loading = true;
        sentinel.classList.add('is-loading');

        var nextPage = page + 1;
        var helpers = window.effiloPopularFilters;
        var filterParams =
          helpers && typeof helpers.getPageFilterParams === 'function'
            ? helpers.getPageFilterParams()
            : null;
        var useFiltered =
          root.dataset.effiloFilterActive === 'true' &&
          filterParams &&
          filterParams.toString() &&
          root.dataset.catalogUrl;

        var url;
        if (useFiltered) {
          url = helpers.buildFilterFetchUrl(
            root.dataset.catalogUrl,
            filterParams,
            nextPage,
            root
          );
        } else {
          url =
            window.location.pathname +
            '?section_id=' +
            encodeURIComponent(sectionId) +
            '&effilo_grid=items&page=' +
            encodeURIComponent(nextPage);
        }

        fetch(url)
          .then(function (response) {
            return response.text();
          })
          .then(function (html) {
            if (useFiltered && helpers && typeof helpers.applyBatchHtml === 'function') {
              var batch = helpers.applyBatchHtml(html, { root: root, list: list }, true);
              if (!batch) return;
              page = parseInt(batch.dataset.page || String(nextPage), 10);
              pages = parseInt(batch.dataset.pages || String(pages), 10);
              root.dataset.effiloInfiniteInit = 'true';
              placeGridImages(root);
              if (batch.dataset.hasMore !== 'true' || page >= pages) {
                setDone();
              }
              return;
            }

            var doc = new DOMParser().parseFromString(html, 'text/html');
            var batch = doc.getElementById('effilo-grid-batch');
            if (!batch) return;

            batch.querySelectorAll('li').forEach(function (li) {
              list.appendChild(li);
            });

            page = parseInt(batch.dataset.page || String(nextPage), 10);
            root.dataset.page = String(page);

            placeGridImages(root);

            if (batch.dataset.hasMore !== 'true' || page >= pages) {
              setDone();
            }
          })
          .catch(function () { })
          .finally(function () {
            loading = false;
            sentinel.classList.remove('is-loading');
          });
      }

      var observer = new IntersectionObserver(
        function (entries) {
          if (entries.some(function (entry) {
            return entry.isIntersecting;
          })) {
            loadMore();
          }
        },
        { rootMargin: '240px 0px' }
      );
      root._effiloObserver = observer;

      if (page < pages) {
        sentinel.hidden = false;
        observer.observe(sentinel);
      } else {
        setDone();
      }
    });
  }

  window.effiloInitInfiniteGrids = initInfiniteGrids;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInfiniteGrids);
  } else {
    initInfiniteGrids();
  }
})();
